import styled from 'styled-components';

export const ImageContainer = styled.div`
  width: 100%;
  padding: 0 24px;
  text-align: center;

  img {
    max-width: 100%;
  }
`;
